// Configuration utility that works in both development and production
// In development: reads from process.env (build-time variables)
// In production (Docker): reads from window.ENV (runtime variables injected by entrypoint script)

const getConfig = () => {
  const runtimeValue = typeof window !== 'undefined' && window.ENV ? window.ENV.REACT_APP_BACKEND_URL : undefined;

  if (runtimeValue && !/\$\{.+\}/.test(runtimeValue)) {
    return { BACKEND_URL: runtimeValue };
  }

  return {
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'
  };
};

export const config = getConfig();
